// ── Native "save image straight to the gallery" (Android) ───────────────────
// Wraps the custom MediaSaverPlugin (android/app/.../MediaSaverPlugin.java),
// which writes a PNG into the device's real public Photos gallery
// (Pictures/Clarity — the same top-level folder the Camera app saves to) via
// MediaStore, so it shows up in Google Photos' main feed and any other
// gallery app. Used instead of @capacitor-community/media, which only wrote
// into this app's own Android/media/<package> folder — files landed there
// invisibly, not in the gallery the user actually checks.
import { registerPlugin, Capacitor } from '@capacitor/core';

const MediaSaver = registerPlugin('MediaSaver');
const isNative = Capacitor.isNativePlatform();

// `dataUrl` is a full `data:image/png;base64,...` URI. `fileName` should not
// include an extension. No-ops (rejects) outside a native build — callers
// should already be gating this behind isNative.
export async function saveImageToDeviceGallery(dataUrl, fileName) {
  if (!isNative) throw new Error('saveImageToDeviceGallery is native-only');
  return MediaSaver.savePng({ dataUrl, fileName });
}
